export enum ReportStatusCode {
    NOT_READY = 'NOT_READY',
    LOADING = 'LOADING',
    READY = 'READY',
    NO_DATA = 'NO_DATA',
    ERROR = 'ERROR',
}
